import React from "react";

interface NumberControllerProps {
  className?: string;
  id: string;
  currentCount: number;
  IncreaseCount: () => void;
  DecreaseCount: () => void;
}

const NumberController: React.FC<NumberControllerProps> = ({
  className = "",
  id,
  currentCount,
  IncreaseCount,
  DecreaseCount,
}) => {
  return (
    <div className={className}>
      <div className="numbersCounter">
        <span className="minus" onClick={DecreaseCount}>
          -
        </span>
        <input
          type="number"
          className="count-room counterInput"
          name="counter"
          id={id}
          value={currentCount}
          readOnly
        />
        <span className="plus" onClick={IncreaseCount}>
          +
        </span>
      </div>
    </div>
  );
};

export default NumberController;
